<ng-container *ngIf='(isLoggedIn$ | async) && !disableUserProfile'>
  <div class='user-profile' nz-dropdown [(nzVisible)]='isVisable' [nzTrigger]="isVisable ? 'click' : 'hover'"
       nzOverlayClassName='user-config-drop-down'
       [nzDropdownMenu]='userAccount'
       nzPlacement='topCenter'>
    <svg width='24' height='24' style='display: block'>
      <use xlink:href='#account-icon'></use>
      <svg xmlns='http://www.w3.org/2000/svg' style='display: none;'>
        <symbol id='account-icon' viewBox='0 0 24 24'>
          <title>Account Icon</title>
          <path stroke-linecap='round' stroke-linejoin='round' stroke-width='.5' fill='currentColor'
                d='M12.0004919,2 C14.9886047,2 17.4109488,4.46243388 17.4109488,7.5 C17.4109488,9.5597022 16.2971847,11.3549656 14.6484833,12.2973839 L20.460623,15.1416122 L22,22 L2,22 L3.54036072,15.1416122 L9.3525004,12.2973839 C7.70379902,11.3549656 6.59003492,9.5597022 6.59003492,7.5 C6.59003492,4.46243388 9.012379,2 12.0004919,2 Z M12.0004919,13.219 L5.24725788,16.525 L4.466,20 L19.533,20 L18.7527421,16.525 L12.0004919,13.219 Z M12.0004919,4 C10.0989655,4 8.55747381,5.56700338 8.55747381,7.5 C8.55747381,9.43299662 10.0989655,11 12.0004919,11 C13.9020182,11 15.4435099,9.43299662 15.4435099,7.5 C15.4435099,5.56700338 13.9020182,4 12.0004919,4 Z'>
          </path>
        </symbol>
      </svg>
    </svg>
  </div>
  <nz-dropdown-menu #userAccount='nzDropdownMenu'>
    <ul nz-menu nzSelectable>
      <li nz-submenu *ngIf='originalContractList.length > 1' [nzTitle]="'menu.switchContract' | translate">
        <nz-input-group [nzSuffix]='suffixIconSearch' class='search-input'>
          <input type='text' nz-input placeholder='Contract Name' [(ngModel)]='searchContractName'
                 (ngModelChange)='searchContract(searchContractName)' />
        </nz-input-group>
        <ng-template #suffixIconSearch>
          <i nz-icon nzType='search' (click)='searchContract(searchContractName)'></i>
        </ng-template>
        <ul [ngStyle]='getContractsDropdownStyle()'>
          <li nz-menu-item *ngFor='let contract of contractList'
              [nzDisabled]='!contract.isEffective'
              [nzSelected]='!!contract.currentActive'
              (click)='switchContract(contract.contractId, !contract.isEffective)'>
            <span nz-icon nzType='check' nzTheme='outline'
                  *ngIf='!!contract.currentActive'></span> {{contract.contractName}}
          </li>
        </ul>
      </li>
      <li (click)="navMenuClick('/user/profile')" nz-menu-item>
        {{ 'menu.profile' | translate }}
      </li>
      <li (click)='logout()' nz-menu-item>{{ 'action.signOut' | translate}}</li>
    </ul>
  </nz-dropdown-menu>

  <nz-badge class="incentive-badge" (click)="showIncentiveModal()" nzStandalone
            [nzCount]="incentiveCount"></nz-badge>

  <app-incentive-modal #incentiveModal *ngIf='incentiveEnable' (closeEvt)='onInentiveModalClose($event)'></app-incentive-modal>
</ng-container>


